import { render, staticRenderFns } from "./InformasiLainnya-Desktop.vue?vue&type=template&id=398902ad&scoped=true"
import script from "./InformasiLainnya-Desktop.vue?vue&type=script&lang=js"
export * from "./InformasiLainnya-Desktop.vue?vue&type=script&lang=js"
import style0 from "./InformasiLainnya-Desktop.vue?vue&type=style&index=0&id=398902ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398902ad",
  null
  
)

export default component.exports